/** Stable id for analytics + localStorage key versioning. Bump when copy variants change. */
export const WELCOME_SPLASH_EXPERIMENT_ID = 'welcome_splash_v4'

const VARIANT_STORAGE_KEY = 'agent_welcome_splash_variant_v4'

const SPLASH_FEATURES = [
  { label: 'Pantry', chipClass: 'step-chip--pantry' },
  { label: 'Cook', chipClass: 'step-chip--recipes' },
  { label: 'Plan', chipClass: 'step-chip--plan' },
  { label: 'Shop', chipClass: 'step-chip--shop' },
  { label: 'Cook Mode', chipClass: 'step-chip--cook' },
]

const SPLASH_FEATURE_STEPS = [
  'Stock your pantry — fridge and freezer too. Takes about a minute.',
  'Save recipes you want to cook this week.',
  'Plan dinners around what you already have.',
  'Shop for what you still need when you are ready.',
]

const ACTIVATION_BASE = {
  eyebrow: 'YOUR KITCHEN',
  title: 'Set up your kitchen in about a minute',
  lead: [
    'Save recipes, pantry, and a meal plan so dinner is easier next week.',
  ],
  features: SPLASH_FEATURES,
  stepsHeading: 'How Captain Cook works',
  steps: SPLASH_FEATURE_STEPS,
  benefitsHeading: '',
  benefits: [],
  trustLine: 'Free to use. No credit card required.',
  ctaSecondary: 'Look around first',
  modalTitle: 'Set up my kitchen',
}

export const WELCOME_SPLASH_COPY = {
  a: {
    ...ACTIVATION_BASE,
    ctaPrimary: 'Set up my kitchen',
  },
  b: {
    ...ACTIVATION_BASE,
    ctaPrimary: 'Set up my kitchen',
  },
}

/**
 * URL override: ?welcomeVariant=a|b (dev / QA). Persisted for consistent funnel joins.
 * @returns {'a'|'b'}
 */
export function getOrAssignWelcomeSplashVariant() {
  try {
    const params = new URLSearchParams(window.location.search)
    const q = (params.get('welcomeVariant') || params.get('welcome_variant') || '').toLowerCase()
    if (q === 'a' || q === 'b') {
      localStorage.setItem(VARIANT_STORAGE_KEY, q)
      return q
    }
    const existing = localStorage.getItem(VARIANT_STORAGE_KEY)
    if (existing === 'a' || existing === 'b') return existing
    const next = Math.random() < 0.5 ? 'a' : 'b'
    localStorage.setItem(VARIANT_STORAGE_KEY, next)
    return next
  } catch {
    return 'a'
  }
}

/** @param {'a'|'b'} variant */
export function getWelcomeSplashCopy(variant) {
  return WELCOME_SPLASH_COPY[variant] ?? WELCOME_SPLASH_COPY.a
}
